import React from 'react'

import Icon, {Icons} from '../icons/Icon'
import KwotaLogo from '../KwotaLogo'
import ProfileMenu from './ProfileMenu'

interface NavigationBarProps {
  mobileMenuOpen: boolean;
  setMobileMenuOpen: () => void;
}

export const NavigationBar = ({
  mobileMenuOpen,
  setMobileMenuOpen
}: NavigationBarProps) => {
  const menuIcon: Icons = mobileMenuOpen ? 'cross' : 'menu'

  return (
    <div className="absolute top-0 right-0 flex items-center justify-between w-full h-20 px-4 lg:hidden bg-kwota-neutral-100">
      <KwotaLogo url="/" className="h-5" />
      <div className="flex items-center gap-3">
        {/**@TODO Mobile Notification component will come here */}
        <ProfileMenu />
        <button onClick={setMobileMenuOpen}>
          <Icon className="fill-kwota-neutral-800" icon={menuIcon} />
        </button>
      </div>
    </div>
  )
}
